import type { SelectProps } from 'antd';
import { Select } from 'antd';
import React from 'react';
import styled from 'styled-components';

import ChevronDownIcon from '../ChevronDownIcon';

type CustomSelectComponent = React.ForwardRefExoticComponent<
  SelectProps<any> & React.RefAttributes<any>
> & {
  Option: typeof Select.Option;
  OptGroup: typeof Select.OptGroup;
};

// Styled wrapper to adjust selector paddings
const SelectWithPadding = styled(Select)`
  .ant-select-selector {
    padding-left: 12px !important;
    /* Leave space for 24px icon + 8px gap */
    padding-right: 32px !important;
  }

  /* Remove extra padding from the displayed value/placeholder */
  .ant-select-single .ant-select-selector .ant-select-selection-item,
  .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    padding-inline-end: 0 !important;
  }

  /* Bring arrow closer to the edge */
  .ant-select-arrow {
    right: 8px;
  }
  /* Ensure search input doesn't underlay the arrow */
  .ant-select-selection-search {
    right: 32px;
  }
`;

const CustomSelect = React.forwardRef<any, SelectProps<any>>((props, ref) => {
  // eslint-disable-next-line react/prop-types
  const { suffixIcon, ...rest } = props;
  return <SelectWithPadding ref={ref} suffixIcon={suffixIcon ?? <ChevronDownIcon />} {...rest} />;
}) as CustomSelectComponent;

CustomSelect.displayName = 'CustomSelect';

// Re-export static members for compatibility with existing code using Select.Option/OptGroup
CustomSelect.Option = Select.Option as any;
CustomSelect.OptGroup = Select.OptGroup as any;

export default CustomSelect;
